// extracted by mini-css-extract-plugin
export default {"positionContainer":"WatchFacesPage_positionContainer__c5LS9","positionBadge":"WatchFacesPage_positionBadge__tO4QX","positionValue":"WatchFacesPage_positionValue__+p0s9"};